import(/* webpackMode: "eager" */ "/home/jenkins/workspace/onents_Frontend_anjuna-ui_master/src/app/page.tsx");
